import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0 bg-primary-500"></div>
      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-6">
        <h2 className="font-heading text-2xl font-bold text-white md:text-4xl">
          {t('cta.title')}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-primary-50 md:text-base">
          {t('cta.text')}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full whitespace-nowrap rounded-md bg-white px-8 py-3.5 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-50 sm:w-auto"
          >
            {t('cta.spread')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full whitespace-nowrap rounded-md bg-accent-500 px-8 py-3.5 text-sm font-bold text-white transition-colors hover:bg-accent-600 sm:w-auto"
          >
            {t('cta.buyNow')}
          </a>
        </div>
      </div>
    </section>
  );
}